import * as ActionType from "./contant";
import ls from "utils/secureLocalStorage";

const STORAGE = "profile";
const initState = {};

const initializeState = () => {
  const config = (function (raw) {
    try {
      return JSON.parse(raw);
    } catch (err) {
      return {};
    }
  })(ls.get(STORAGE));
  let state;
  if (config) {
    state = config;
  } else {
    state = initState;
  }

  return state;
};

const reducer = (state = initializeState(), action) => {
  const { type, value } = action;

  switch (type) {
    case ActionType.SET_PROFILE:
      ls.set(STORAGE, JSON.stringify(value));
      return { ...value };
    case ActionType.UPDATE_PROFILE:
      ls.set(STORAGE, JSON.stringify({ ...state, ...value }));
      return { ...state, ...value };
    case ActionType.CLEAR_PROFILE:
      ls.clear(STORAGE)
      return {};
    default:
      return state;
  }
};

export default reducer;
